import * as React from "react";
function SvgArrowUp(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M3.256 9.63L7 5.888l3.744 3.744.756-.756-4.5-4.5-4.5 4.5.756.756z" fill="currentColor" /></svg>;
}
export default SvgArrowUp;